import type React from 'react';

import type { IconProps } from '../types';

export const ChevronDownXs: React.FC<IconProps> = ({ color = 'currentColor', ...props }) => (
  <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11.7607 5.70007C12.0451 5.96421 12.0775 6.39783 11.8486 6.70104L8.54978 10.2606C8.40793 10.4133 8.20838 10.4998 7.99997 10.4999C7.79147 10.4999 7.59207 10.4134 7.45017 10.2606L4.20017 6.76061C3.91836 6.45712 3.93581 5.98193 4.23923 5.70007C4.54273 5.41851 5.01799 5.4358 5.29978 5.73913L7.99997 8.64636L10.7558 5.6864C11.0413 5.43566 11.4763 5.43593 11.7607 5.70007Z"
      fill={color}
    />
  </svg>
);
